/**
 * Rows selectors
 */

import { SubjectArea } from 'features/subjectArea/types';
import { SubjectAreaGridData } from 'features/subjectArea/types/common';
import { getSlice } from './';

/**
 * Gets all the loaded row data
 * @param state redux state
 * @returns An object byId / allIds for the loaded row data
 */
export const getAllRowData = (page: SubjectArea.AnalysisPage) => (
	state: RootState
): SubjectAreaGridData.Rows<SubjectAreaGridData.GridRow> | undefined => {
	const slice = getSlice(page)(state);
	return slice.rows;
};

/**
 * Gets a single row id for the active exam level
 * @param page the active page
 * @param activeExamLevel active page exam level
 * @returns string array
 */
export const getRowIdsByExamLevel = (
	page: SubjectArea.AnalysisPage,
	activeExamLevel: SubjectArea.ExamLevels
) => (state: RootState): string[] => {
	const data = getAllRowData(page)(state);

	return data
		? Object.values(data.byId)
				.filter((row) => row.examLevelId === activeExamLevel)
				.map((row) => row.rowId)
		: [];
};
